// MST
import { types, flow, cast } from 'mobx-state-tree'

import {
  IAboutUsFounderGetAttrs,
  IAboutUsFounderSaveAttrs,
} from 'interfaces/back-office/content-management/about-us/founder/about-us-founder-view.interface'
import {
  IAboutUsFounderApiGetResponse,
  IAboutUsFounderApiSaveResponse,
} from 'interfaces/back-office/content-management/about-us/founder/about-us-founder-api.interface'
import { IAboutUsFounder } from 'interfaces/back-office/content-management/about-us/founder'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'

// About Us Founder Props
const aboutUsFounderProps = {
  id: types.maybeNull(types.number),
  content: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  status: types.maybeNull(types.boolean),
  createdAt: types.maybeNull(types.string),
  updatedAt: types.maybeNull(types.string),
}

const AboutUsFounder = types.model('aboutUsFounder').props(aboutUsFounderProps)

const AboutUsFounderStoreModel = types
  .model('aboutUsFounder')
  .props({
    aboutUsFounder_isLoading: types.optional(types.boolean, false),
    aboutUsFounder_isSaveLoading: types.optional(types.boolean, false),
    aboutUsFounder_aboutUsFounder: types.optional(AboutUsFounder, {}),
  })
  .actions(self => ({
    aboutUsFounder_SET_LOADING: (payload: boolean): void => {
      self.aboutUsFounder_isLoading = payload
    },
    aboutUsFounder_SET_SAVE_LOADING: (payload: boolean): void => {
      self.aboutUsFounder_isSaveLoading = payload
    },
    aboutUsFounder_SET_ABOUT_US_FOUNDER: (payload: IAboutUsFounder): void => {
      self.aboutUsFounder_aboutUsFounder = cast(payload)
    },
    aboutUsFounder_CLEAR_ABOUT_US_FOUNDER: (): void => {
      self.aboutUsFounder_aboutUsFounder = cast({})
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch about us founder
     *
     * @param {IAboutUsFounderGetAttrs} payload
     *
     * @return {any} any
     */
     aboutUsFounder_fetchAboutUsFounder: flow(function* (payload: IAboutUsFounderGetAttrs) {
      self.aboutUsFounder_SET_LOADING(true)

      const response: IAboutUsFounderApiGetResponse = yield self.environment.aboutUsFounderApi.aboutUsFounder_getAboutUsFounder({
        requestConfig: { ...payload.requestConfig },
      })
      if (response.ok) {
        self.aboutUsFounder_SET_ABOUT_US_FOUNDER(response.res.data)

        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response error
        if (payload?.onError) payload.onError()
      }

      self.aboutUsFounder_SET_LOADING(false)
    }),

    /**
     * @description Save about us founder
     *
     * @param {IAboutUsFounderSaveAttrs} payload
     *
     * @return {any} any
     */
    aboutUsFounder_saveAboutUsFounder: flow(function* (payload: IAboutUsFounderSaveAttrs) {
      self.aboutUsFounder_SET_SAVE_LOADING(true)

      const response: IAboutUsFounderApiSaveResponse = yield self.environment.aboutUsFounderApi.aboutUsFounder_saveAboutUsFounder({
        params: { ...payload.params },
        body: { ...payload.body },
        requestConfig: { ...payload.requestConfig },
      })
      if (response.ok) {
        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      self.aboutUsFounder_SET_SAVE_LOADING(false)
    }),
  }))

  export const createAboutUsFounderStoreDefaultModel = () => types.optional(AboutUsFounderStoreModel, {})